import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { muteRemotePhoneUserRequested } from 'features/sip/actions';

export function* muteRemotePhoneAudioSaga(action: ReturnType<typeof muteRemotePhoneUserRequested>) {
  logger
    .remote({ action: true, tier: 1 })
    .log(`Mute phone audio remotely for the user id=${action.payload.id}`);

  yield call(SignalingSocket.send, {
    event: 'mutePhoneUser',
    data: {
      id: action.payload.id,
    },
  });
}
